<template>
  <b-form-group
      :label="$t('user.Password') + (isEdit ?'' : ' *')"
      label-for="password-input"
      class="bold-label"
      :state="password.state"
      :invalid-feedback="password.invalidFeedback"
      :description="(isEdit ? 'Laisser vide pour conserver le mot de passe actuel' : '' )"
  >
    <div class="password-line">
      <b-form-input
          id="password-input"
          :placeholder="$t('user.Password')"
          v-model="password.value"
          :type="showPassword ?'text' : 'password'"
          :required="!isEdit"
          :minLength="minLength"
      ></b-form-input>
      <b-button variant="light" @click="togglePassword">
        <eye-icon v-if="!showPassword"></eye-icon>
        <eye-off-icon v-else></eye-off-icon>
      </b-button>
      <b-button variant="light" @click="generatePassword">
        <refresh-icon></refresh-icon>
      </b-button>
    </div>
  </b-form-group>
</template>

<script>
export default {
  name: "PasswordCreationField",

  props: {
    minLength: {
      type: Number,
      default: 7
    },
    isEdit: {
      type: Boolean,
      default: null
    },
  },

  data() {
    return {
      password: {
        state: null,
        invalidFeedback: null,
        value: null
      },
      showPassword: false,
    }
  },

  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    generatePassword() {
      var chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      var passwordLength = 8;
      var passwordG = "";
      for (var i = 0; i <= passwordLength; i++) {
        var randomNumber = Math.floor(Math.random() * chars.length);
        passwordG += chars.substring(randomNumber, randomNumber + 1);
      }
      this.password.value = passwordG;
    },
    sendInfosToParent() {
      this.$emit(
          'passwordInfos',
          this.password.state,
          this.password.invalidFeedback,
          this.password.value,
      )
    },
  },
  watch: {
    'password.value': function () {
      this.sendInfosToParent();
    }
  }
}
</script>

<style scoped>
.password-line {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/b122/PasswordCreationField.vue